<template>
    <div class="connection-container">
        <div :class="{active: canInvite}" class="btn createInvite" @click="addNewInvite">创建邀请</div>
        <simple-tab :tab-list="tabList" :active.sync="active" :tag="tag"></simple-tab>
        <div class="content">
            <div v-if="!active">
                <div class="empty" v-if="!list.length && !cancelList.length">
                    你暂时没有关联的up主～
                </div>
                <connection-card v-for="item in list" :app-pid="appPid" :key="item.appId" :item="item" @refresh="getList" :status="0" class="card"></connection-card>
                <div class="empty-invite" v-if="!list.length">
                    <p class="tip" v-if="!list.length && cancelList.length">暂无关联的up主</p>
                    <div v-if="canInvite" :class="{active: canInvite, 'empty-btn': !list.length && !cancelList.length}" class="btn" @click="addNewInvite">创建邀请</div>
                </div>
                <!-- <p :class="{top: !list.length}" class="title" v-if="cancelList.length">取消关联up主</p>
                <connection-card v-for="item in cancelList" :app-pid="appPid" :key="item.appId" :item="item" @refresh="getList" :status="1" class="card"></connection-card> -->
            </div>
            <div v-else>
                <div class="limit-text">
                    小程序可邀请up主上限为：{{appInfo.maxUpCount}}
                </div>
                <div>
                    <div class="empty" v-if="!inviteList.length && !cancelInviteList.length">
                        你暂时没有邀请的up主～
                    </div>
                    <connection-card v-for="item in inviteList" :app-pid="appPid" :key="item.appId" :item="item" @refresh="getList" :status="2" class="card"></connection-card>
                    <div class="empty-invite" v-if="!inviteList.length">
                        <p class="tip" v-if="!inviteList.length && cancelInviteList.length">暂无邀请中的up主</p>
                        <div v-if="canInvite" :class="{active: canInvite, 'empty-btn': !inviteList.length && !cancelInviteList.length}" class="btn" @click="addNewInvite">创建邀请</div>
                    </div>
                    <p class="title" v-if="cancelInviteList.length">取消邀请up主</p>
                    <connection-card v-for="item in cancelInviteList" :app-pid="appPid" :key="item.appId" :item="item" @refresh="getList" :status="3" class="card"></connection-card>
                </div>
            </div>
        </div>
        <new-invite-dialog :app-pid="appPid" v-if="dialogVisible" :logo="appInfo.logo" :name="appInfo.name" :introduction="appInfo.introduction" @cancel="closeDialog" @save="addInvite"></new-invite-dialog>
        <result-dialog v-if="resultDialogVisible" :app-id="newAppId" @cancel="closeDialog"></result-dialog>
    </div>
</template>
<script>
import SimpleTab from '@/components/SimpleTab.vue';
import ConnectionCard from '@/components/ConnectionCard.vue';
import NewInviteDialog from '@/components/NewInviteDialog.vue';
import ResultDialog from './ResultDialog.vue';
import Btn from '@/components/Button.vue'
import dao from '@/lib/dao.js';
export default {
    props: {
        appInfo: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    components: {
        SimpleTab,
        ConnectionCard,
        NewInviteDialog,
        ResultDialog,
        Btn
    },
    data() {
        return {
            list: [],
            cancelList: [],
            inviteList: [],
            cancelInviteList: [],
            active: 0,
            dialogVisible: false,
            newAppId: 0,
            resultDialogVisible: false,
            appPid: 0,
            tag: 'up'
        }
    },
    computed: {
        param() {
            return {
                appPid: this.appPid,
                linkedAndCanceled: !this.active,
                linkingAndCanceled: !!this.active
            }
        },
        tabList() {
            let { linkingUpNum, linkedUpNum } = this.appInfo;
            return [
                `已关联${typeof linkedUpNum === 'undefined' ? '' : '（' + linkedUpNum + '）'}`,
                `邀请中${typeof linkingUpNum === 'undefined' ? '' : '（' + linkingUpNum + '）'}`
            ];
        },
        canInvite() {
            return (this.appInfo.linkingUpNum + this.appInfo.linkedUpNum) < this.appInfo.maxUpCount;
        }
    },
    watch: {
        active() {
            this.getList();
        }
    },
    methods: {
        closeDialog() {
            this.dialogVisible = false;
            this.resultDialogVisible = false;
        },
        addInvite(data) {
            data.appId = this.appPid;
            dao.shop.addInvite(data).then(data => {
                this.getList();
                this.dialogVisible = false;
                this.resultDialogVisible = true;
                this.newAppId = data;
                this.appInfo.linkingUpNum++;
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        getList() {
            dao.shop.getUpList(this.param).then(data => {
                data.list = data.list || [];
                if (!!this.active) {
                    this.inviteList = [];
                    this.cancelInviteList = [];
                    data.list.forEach(item => {
                        if (item.status == 0) {
                            this.inviteList.push(item);
                        } else if (item.status == 11 || item.status == 10) {
                            this.cancelInviteList.push(item);
                        }
                    });
                    this.appInfo.linkingUpNum = this.inviteList.length;
                } else {
                    this.list = [];
                    this.cancelList = [];
                    data.list.forEach(item => {
                        if (item.status >= 1 && item.status <= 3 ) {
                            this.list.push(item);
                        } else if (item.status == 12 || item.status == 13) {
                            this.cancelList.push(item);
                        }
                    });
                    this.appInfo.linkedUpNum = this.list.length;
                }
            })
        },
        addNewInvite() {
            if ((this.appInfo.linkingUpNum + this.appInfo.linkedUpNum) >= this.appInfo.maxUpCount) {
                this.$message.error('邀请人数已达上限');
            } else {
                this.dialogVisible = true;
            }
        }
    },
    mounted() {
        this.appPid = this.$route.params.appId;
        this.getList();
    }
}
</script>
<style lang="less" scoped>
.connection-container {
    position: relative;
    .createInvite {
        position: absolute;
        right: 0;
        top: -3px;
        &.btn {
            width: 85px;
        }
    }
    .btn {
        text-align: center;
        cursor: pointer;
        border-radius: 2px;
        display: inline-block;
        box-sizing: border-box;
        font-size: 0;
        height: 32px;
        width: 96px;
        line-height: 32px;
        display: inline-block;
        font-size: 14px;
        vertical-align: middle;
        background: #F6F8FA;
        color: #9AA7C1;
        border: 1px solid #E0E5EC;
        margin-left: 10px;
        &.active {
            background: #789AFF;
            color: #fff;
            border: none;
        }
    }
    .content {
        padding: 25px;
        background: #fff;
        border: 1px solid #E0E5EC;
        min-height: 500px;
        font-size: 16px;

        .card {
            margin-right: 10px;
            margin-bottom: 10px;
        }
        .title {
            margin-top: 30px;
            margin-bottom: 18px;
            font-size: 16px;
            color: #6D757A;
            &.top {
                margin-top: 0;
            }
        }
        .limit-text {
            font-size: 14px;
            color: #5C667E;
            margin-bottom: 20px;
        }
        .empty-invite {
            margin: 5px auto 40px;
            color: #6D757A;
            text-align: center;
            .tip {
                font-size: 14px;
                margin-bottom: 14px;
            }
            .btn {
                width: 85px;
                &.active {
                    border: 1px solid #789AFF;
                    color: #789AFF;
                    background-color: #fff;
                }
            }
            
        }
        .empty {
            padding-top: 160px;
            font-size: 14px;
            color: #5C667E;
            text-align: center;
            background: url(./../../assets/empty.png) center 0 no-repeat;
            background-size: 298px 153px;
            margin-top: 60px;
        }
        .empty-btn {
            margin-top: 15px;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/page/manage/Connection.vue